function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.46378 18V9.78936H9.35847L9.79186 6.5895H6.4637V4.54653C6.4637 3.6201 6.73388 2.98879 8.12932 2.98879L9.90901 2.98799V0.126072C9.6012 0.0871459 8.54468 0 7.3157 0C4.74968 0 2.99294 1.49118 2.99294 4.22972V6.5895H0.0908203V9.78936H2.99294V17.9999L6.46378 18Z",
  fill: "#FAF9FC"
});
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.2f8ff5e75d5dd4468d8945daa257000a.svg";
export { ForwardRef as ReactComponent };